import type { FaireProductEntity } from "../../entity_types/product";

export const p_s9vkfcbt95: FaireProductEntity = {
  token: "p_s9vkfcbt95",
  type: "product",
  name: "Peppermint Magnesium Muscle & Sleep Rub",
  brandToken: "b_ad8bjvlw5g",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1377146c2cf0c98a91559a0ba31b2be3e4ad04eb2af33886f14fec63d76d7d9a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/76c8f44d1bce282aa739d43dc5114ea33c4c03b9d0e9e9eb0bc0834b9c67b1e2.jpeg",
    "https://cdn.faire.com/fastly/d491c15d4b20a69145af8964d2e8e984437f7777cac792d9042ef9eded3ee29d.jpeg",
    "https://cdn.faire.com/fastly/5dff2352ca0942ff21161cc3cb6be436d3f39065fd488eeb0bbe3d0d32d8b366.jpeg",
    "https://cdn.faire.com/fastly/109ca4539f24c048fc4f368c16a3b0ae1ef943867d6e81a7abf3ca946c651a3b.png",
    "https://cdn.faire.com/fastly/7c8a77552be337c5747c3ad89d6fb6b6b2e204110a31506ad763d546692c5d37.jpeg",
    "https://cdn.faire.com/fastly/2cfad2adea373793d451f3592e119fd07768e329a38dc9aa043f2e2c53426728.png",
  ],
  priceDollars: 10.4,
  description:
    "✔️ Plant Based ✔️ Cruelty Free ✔️ Eco Friendly\n\nRich, creamy and naturally scented, this Peppermint Magnesium Cream is all about relief and relaxation. Help replenish the magnesium in your body by absorbing it topically and reap the benefits of a mineral required for many bodily functions.\n- Magnesium helps relax nerves therefore relieving tension and aiding in rest and sleep.\n- Apply to sore muscles for relief or to the bottom of your feet for a better night's sleep.\n- Due to the menthol component, Peppermint Essential Oil may help with tension.\nDirections\n\nApply all over body or where ever you may feel sore. Rinse hands after application. For external use only.\n\n***Full size product will come boxed unless otherwise specifically requested.***\n\nIngredients: Butyrospermum Parkii (Shea) Butter, Cocos Nucifera (Coconut) Oil, Cera Alba, Magnesium Chloride, Mentha Piperita (Peppermint) Oil, Glyceryl Oleate Citrate, Tocopheryl Acetate, Caprylic/Capric Triglyceride, Dehydroacetic Acid, Benzyl Alcohol, Sodium Phytate, Natural Preservative.\n\nUnTamed Naturals does not make any medical claims. Always store natural products in a cool and dry place, avoid getting water in jar. ",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:28.605Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
